import type { FirebaseApp } from 'firebase/app';
import { initializeApp } from 'firebase/app';
import type { Firestore } from 'firebase/firestore';
import { getFirestore } from 'firebase/firestore';

import { appEnv } from '../config';
import { firebaseConfig } from './config';

const firestoreDbName = firebaseConfig[appEnv]?.firestoreDbName;

let firebaseApp: FirebaseApp | undefined;
let firestoreDb: Firestore | undefined;

export const getFirebaseApp = () => {
  if (firebaseApp) {
    return firebaseApp;
  }

  firebaseApp = initializeApp(firebaseConfig[appEnv]);
  return firebaseApp;
};

export const getFirestoreDb = () => {
  if (firestoreDb) {
    return firestoreDb;
  }

  const firebase = getFirebaseApp();
  firestoreDb = firestoreDbName ? getFirestore(firebase, firestoreDbName) : getFirestore(firebase);
  return firestoreDb;
};
